import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_j732ad6fru: FaireBrandEntity = {
  token: "b_j732ad6fru",
  type: "brand",
  name: "First Honey",
  avatarUrl:
    "https://cdn.faire.com/fastly/08f013eb306c945df9bebf381e2f44d5acbd518bbb7134ec940c0a2c70d6e9e5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0345731c6aed24e1fdfbb43ef1ebe00068a7e4aeb96cde834fe40f42ee5466b5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/08f013eb306c945df9bebf381e2f44d5acbd518bbb7134ec940c0a2c70d6e9e5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0345731c6aed24e1fdfbb43ef1ebe00068a7e4aeb96cde834fe40f42ee5466b5.jpeg",
  location: "Nashville, TN, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 16,
  isTopShop: true,
  isInsider: true,
  description:
    "At First Honey, we are the leading global experts in medical grade Mānuka honey, specializing in natural, antibiotic-free wound care, nutrition, and body treatments.\n\nOur legacy is sweet. We're proud to share our story, which starts with our family owned farm in New Zealand, where we personally care for hundreds of beehives\non rolling hills of Mānuka, and ends with you, whose life we help to sweeten every day!\n\nVisit us online to learn more about our story and our bees.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:39.901Z",
    importedBy: "entity-db-cli",
  },
};
